document.addEventListener('DOMContentLoaded', function() {
var swarowskiSelect = document.querySelector('#swarovskiDropdown');
if (swarowskiSelect) {
        swarowskiSelect.addEventListener('change', function(ev) {
        let image = swarowskiSelect.selectedOptions[0].getAttribute('data-image');
        let imageContainer = document.querySelector('.woocommerce-product-gallery__image');
        imageContainer.setAttribute('data-thumb', image);
        imageContainer.querySelector('a').setAttribute('href', image);
        imageContainer.querySelector('a img').setAttribute('src', image);
        imageContainer.querySelector('a img').setAttribute('data-src', image);
        imageContainer.querySelector('a img').setAttribute('data-large_image', image);
        imageContainer.querySelector('a img').removeAttribute('srcset');

        imageContainer.querySelector('img.zoomImg').setAttribute('src', image);
        imageContainer.querySelector('img.zoomImg').setAttribute('data-src', image);
        imageContainer.querySelector('img.zoomImg').setAttribute('title', swarowskiSelect.selectedOptions[0].innerHTML);
  
      });
    }
    let ringSizeSelect = document.querySelector('#ringsize');
    if (ringSizeSelect) {
      var infotext = document.querySelector('.ringSizeFee');
      var fee = Number.parseInt(document.querySelector('#big_ring_size_cost').innerHTML);
      ringSizeSelect.addEventListener('change', function(ev) {
        if (ev.target.value >= 60) {
          infotext.classList.remove('ringSizeFee--hidden');
          if (product_price <= initialPrice + fee) {
            product_price = initialPrice + fee;
          }
        } else {
          infotext.classList.add('ringSizeFee--hidden');
          if (product_price >= initialPrice) {
            product_price = initialPrice;
          }
        }
        priceContainer.lastChild.nodeValue = format_price(product_price);
      });
    }
});